var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityIcon24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440",
    transform: "translate(-1418 -3751)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(1418 3751)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_bar_building",
    d: "M13.9.914,1,6.346V26.808H26.793V6.346Zm0,2.546L24.448,7.9v16.56H3.345V7.9ZM10.606,8.049l-.275.785L9.475,11.3a4.56,4.56,0,0,0,1.988,5.5,5.1,5.1,0,0,0,1.262.327v2.647H10.379v2.345h7.034V19.773H15.069V17.126a5.1,5.1,0,0,0,1.259-.327,4.563,4.563,0,0,0,1.99-5.5L17.185,8.049Zm1.665,2.345H15.52l.586,1.676a2.431,2.431,0,0,1,.128.669H11.559a2.415,2.415,0,0,1,.128-.669Z",
    transform: "translate(1434 3767.086)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon24);
export default __webpack_public_path__ + "static/media/facilityIcon24.d0b029e2ef9408274bdd40d5c9c04a03.svg";
export { ForwardRef as ReactComponent };